import { useApiQuery } from 'src/infrastructure/rest-api/useApi';

export const useSubStyleCategoriesApiQuery = () => {
    const { data, loading, error, refetch } = useApiQuery('/api/stylesubcategories', 'get');
    return { data, loading, error, refetch };
};
